



















import { Component, Prop, Vue } from "@/shared/vuepack";
import moment from "moment";
import _ from "lodash";
import { useDrivewealthAccountPerformanceStore } from "@/shared/store/drivewealthAccountPerformance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import {
  DrivewealthAccountIdentifierArgs, DrivewealthAccountPerformance,
  DrivewealthAccountPerformanceFrequency,
  DrivewealthAccountPerformanceSelectOption,
  DrivewealthAccountPerformanceTimePeriod,
  DrivewealthAccountSummary
} from "@/shared/types";
import Select from "@/shared/components/ui/Select.vue";

@Component({
  computed: {
    DrivewealthAccountPerformanceFrequency () {
      return DrivewealthAccountPerformanceFrequency;
    },
    DrivewealthAccountPerformanceTimePeriod () {
      return DrivewealthAccountPerformanceTimePeriod;
    }
  }
})
export default class AccountPerformanceForm extends Vue {
  drivewealthAccountPerformanceStore = useDrivewealthAccountPerformanceStore();
  drivewealthStore = useDrivewealthStore();

  @Prop()
  accountId: number;

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  moment = moment;
  selectedTimePeriod = DrivewealthAccountPerformanceTimePeriod.YearToDate;
  dateNow = moment();
  isSubmitting = false;

  mounted (): void {
    this.selectedTimePeriod = this.drivewealthAccountPerformanceStore.selectedTimePeriod;
  }

  get accountIdentifiers (): DrivewealthAccountIdentifierArgs {
    return {
      username: this.username,
      partnerId: this.partnerId,
      accountId: this.accountId
    };
  }

  get frequencySelectOptions (): DrivewealthAccountPerformanceSelectOption[] {
    const selectOptions = [];
     Object.keys(DrivewealthAccountPerformanceTimePeriod)
        .forEach(k => {
          const timePeriodOption = DrivewealthAccountPerformanceTimePeriod[k];
          const lookup = _.find(this.timePeriodOptions, x => x.value === timePeriodOption);
          selectOptions.push(lookup);
        });

     return selectOptions;
  }

  get timePeriodOptions (): DrivewealthAccountPerformanceSelectOption[] {
    return [
      {
        label: "1 Month",
        value: DrivewealthAccountPerformanceTimePeriod.Months1,
        frequency: DrivewealthAccountPerformanceFrequency.Daily,
        fromDate: moment().subtract(1, "months")
      },
      {
        label: "3 Months",
        value: DrivewealthAccountPerformanceTimePeriod.Months3,
        frequency: DrivewealthAccountPerformanceFrequency.Monthly,
        fromDate: moment().subtract(3, "months")
      },
      {
        label: "6 Months",
        value: DrivewealthAccountPerformanceTimePeriod.Months6,
        frequency: DrivewealthAccountPerformanceFrequency.Monthly,
        fromDate: moment().subtract(6, "months")
      },
      {
        label: "YTD",
        value: DrivewealthAccountPerformanceTimePeriod.YearToDate,
        frequency: DrivewealthAccountPerformanceFrequency.Monthly,
        fromDate: moment().subtract(moment().diff(moment().startOf("year"), "days"), "months")
      },
      {
        label: "3 Years",
        value: DrivewealthAccountPerformanceTimePeriod.Years3,
        frequency: DrivewealthAccountPerformanceFrequency.Yearly,
        fromDate: moment().subtract(3, "years")
      },
      {
        label: "5 Years",
        value: DrivewealthAccountPerformanceTimePeriod.Years5,
        frequency: DrivewealthAccountPerformanceFrequency.Yearly,
        fromDate: moment().subtract(5, "years")
      }
    ];
  }

  get accountCreationDate (): string {
    if (this.accountSummary) {
      return moment(this.accountSummary.dateCreated).format("YYYY-MM-DD");
    }

    return "";
  }

  get accountSummary (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  get accountPerformanceResult (): DrivewealthAccountPerformance {
    return this.drivewealthAccountPerformanceStore.accountPerformanceResult(this.accountIdentifiers);
  }

  getAccountPerformance (selectOption: DrivewealthAccountPerformanceSelectOption): void {
    if (this.isSubmitting) {
      return;
    }

    this.selectedTimePeriod = selectOption.value;

    this.isSubmitting = true;

    this.drivewealthAccountPerformanceStore.setFromDate(selectOption.fromDate.format("YYYY-MM-DD"));
    this.drivewealthAccountPerformanceStore.setSelectedTimePeriod(selectOption.value);
    this.drivewealthAccountPerformanceStore.setSelectedFrequency(selectOption.frequency);
    this.drivewealthAccountPerformanceStore.getAccountPerformance(this.accountIdentifiers)
        .then(x => this.isSubmitting = false);
  }
}
